import Splide from '@splidejs/splide'
import Alpine from 'alpinejs'

export const initImages = () => {
    Alpine.data('initImages', () => ({
        init() {
            new Splide(this.$el, {
                type: 'fade',
                gap: 0,
                isNavigation: false,
                arrows: true,
                pagination: false,
                lazyLoad: 'nearby',
            }).mount()
        },
    }))
}
